<div class="dds-modal-overlay" (click)="close()"></div>

<div ddsResize class="dds-modal dds-modal_md">
  <div class="dds-modal__header">
    <span class="dds-modal__title">Edit document</span>
    <dds-button
      size="sm"
      icon="dds-icon_close"
      kind="silent"
      theme="dark"
      ariaLabel="Close modal"
      class="dds-modal__close"
      (clicked)="close()"
    ></dds-button>
  </div>

  <div class="dds-modal__body">
    <div class="inputs-container">
      <div
        *ngIf="showRMReviewedGuidanceNote"
        class="sub-text-section d-flex margin-top-xs relative"
      >
        <span class="icon-s inline-block relative icon-pinned"></span>
        <span>
          <div class="eclipse-header-grey padding-left-xs">
            {{ rmReviewedGuidanceNoteHeader }}
          </div>
          <div
            class="vertical-line-green absolute"
            *ngIf="showRMReviewedGuidanceNote"
          ></div>
        </span>
      </div>
      <div class="padding-left-l padding-bottom-m">
        <span>
          <div
            class="margin-top-xs text-gray"
            *ngIf="showRMReviewedGuidanceNote"
          >
            <div class="eclipse-content-grey">
              {{ rmReviewedGuidanceNoteBody }}
            </div>
          </div>
        </span>
      </div>
      <div class="margin-bottom-l">
        <div class="d-flex">
          <span
            *ngIf="!documentTitle"
            class="icon-required-yellow col-md-1 padding-left-sm padding-bottom-s inline-block"
          ></span>
          <p class="input-label font-size-12">File title</p>
        </div>
        <dds-input [(ngModel)]="documentTitle" [placeholder]="'Add file title'">
        </dds-input>
      </div>

      <div class="row margin-bottom-l">
        <p class="input-label font-size-12">Type</p>
        <dds-select
          [(ngModel)]="selectedDocType"
          [list]="documentTypeOptions"
          (ngModelChange)="onDocTypeChange($event)"
        ></dds-select>
      </div>
      <div class="row row margin-bottom-l">
        <p class="input-label font-size-12">Status</p>
        <dds-select
          [list]="documentStatusOptions"
          [(ngModel)]="selectedDocStatus"
          (ngModelChange)="onDocStatusChange()"
        ></dds-select>
      </div>

      <div class="comment margin-bottom-l">
        <p class="input-label font-size-12">Comment (optional)</p>
        <dds-textarea [placeholder]="'Text'" [(ngModel)]="documentComment">
        </dds-textarea>
      </div>
    </div>
  </div>

  <div class="dds-modal__footer">
    <div class="dds-modal__footer-content dds-modal__footer-content_left">
      <dds-button
        class="dds-modal__footer-item"
        (clicked)="closeAll()"
        (keyboardClicked)="closeAll()"
        [disabled]="isSaveDisabledCheck() || !documentTitle"
        >Save</dds-button
      >
      <dds-button
        class="dds-modal__footer-item"
        kind="secondaryLoud"
        (clicked)="close()"
        (keyboardClicked)="close()"
        >Close</dds-button
      >
    </div>
  </div>
</div>
